import { appConstants } from "../_constants";
import { appHelpers, authHeader, authFileHeader, authBlobHeader } from "../_helpers";

export const commonService = {
  getAllAirlines,
  getAirlinesCarriers,
  getAllAirports,
  filterGetAirports,
  getAllCountries,
  getFlights,
  getFlight,
  getAirlinesFlightNumbers,
  getFlightDays,
  getDashboardReport,
  getInvoiceReconciliation,
  getInvoiceReconciliationByProcessName,
  getInvoiceReconciliationFiles,
  manageFlight,
  manageAirport,
  getIATAReports,
  generateInternationalIATAReports,
  generateDomesticIATAReports,
  manageAirline,
  markReportDownloaded,
  getFTPCredentials,
  manageFTPCredential,
  deleteFTPCredential,
  bulkDeleteManifest,
  deleteManifestByReference,
  downloadManifest,
  downloadInvoiceReport,
  downloadProformaReport,
  generateInvoice,
  uploadBillingSummary,
  uploadPayment,
  uploadManifest,
  downloadPdfAndExcel,
  getInvoiceIssuers,
  getProformaReport,
  getUnmatchPayments,
  getUnmatchedDomesticPayments,
  processUnmatchedDomesticPayment,
  paymentReconciliation,
  getReconciliationById,
  getMatchingPayments,
  processUnmatchedPayment,
  pdmDownloadPdf,
  pdmDownloadExcel,
  billedPerAirportDownloadPdf,
  billedPerAirportDownloadXls,
  getWorkFlows,
  getWorkFlowProcess,
  getWorkFlowUsers,
  getUsersByOrganization,
  createWorkflow,
  createWorkflowUser,
  removeWorkflowUser,
  getIATAValidation,
  postIATAValidation,
  searchIATAValidationDetails,
  updateIATAValidationDetail,
  transitionIataWorkflowState,
  reInitializeWorkflowState,
  addBulkPdm,
  searchAppEntityTypes,
  searchMakerChecker,
  createMakerChecker,
  approveMakerChecker,
  rejectMakerChecker,
  searchManifestPullModes,
  searchManifestProcessDuration,
  searchManifestStatus,
  searchAirlineLocations,
  getFlagMetrics,
  getTicketClass,
  getTicketCategory,
  searchTicketCategoryDetails,
  saveTicketCategoryDetails,
  createFlagMetrics,
  createAirlineLocation,
  createTicketClass,
  getSecurityChargeReport,
  downloadSecurityChargeReport,
  downloadInvoiceReconciliationReport,
  downloadFinalDestinationReport,
  getDataCount,
  indexManifest,
  getAirlineWallet,
  downloadWalletHistory,
  getAuditTrail,
  getAuditActions,
  InitiateDisputeLog,
  approveDisputeLog,
  rejectDisputeLog,
  saveDisputeLog,
  searchDispute,
  getTicketNumbers,
  fetchUploadManifest,
  getDashboardRecord,
  getFaqs,
  getAggregateNewPassengers,
  fetchTicketInfo,
  newbilledPerAirportDownloadPdf,
  newbilledPerAirportDownloadXls,
  updatePdmRecord,
  downloadAggregateTSC, 
  downloadSpecificIataReport
};

function getInvoiceReconciliation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/BillSummary/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getInvoiceReconciliationByProcessName(billSummaryFileId) {
  return appHelpers
    .getRequest(
      `${
        appConstants.PAS_URL
      }/api/BillSummary/GetBillBreakdown?billSummaryFileId=${billSummaryFileId}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getInvoiceReconciliationFiles(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/BillSummaryFile/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getReconciliationById(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Payment/GetReconciliation?reconId=${
        payload.Id
      }`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getMatchingPayments(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Payment/MatchingBDSearch`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function processUnmatchedPayment(payload) {
  return appHelpers
    .getRequest(
      `${
        appConstants.PAS_URL
      }/api/Payment/ProcessUnmatchedPayment?billedDetailsId=${
        payload.billedDetailsId
      }&reconciliationId=${payload.reconciliationId}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function processUnmatchedDomesticPayment(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/UnmatchedPayment/ProcessMatchedPayment`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllAirlines() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/airline/search`, authHeader())
    .then(res => {
      return res;
    });
}
function getAirlinesCarriers() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/airline/search?carrier=true`,
      authHeader()
    )
    .then(res => {
      return res;
    });
}

function getAllAirports() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/airport/search`, authHeader())
    .then(res => {
      return res;
    });
}
function filterGetAirports(url) {
  // return appHelpers.getRequest(url, authHeader());
  return appHelpers.getRequest(url, authHeader()).then(res => {
    return res;
  });
}
function getAllCountries() {
  let payload = { From: 0, PageSize: 300, Parameter: {} };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Country/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    });
}
function getFlightDays() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Days/search`, authHeader())
    .then(res => {
      return res;
    });
}

function getFlights(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/search?showdetails=true`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getAirlinesFlightNumbers(airlineId) {
  let payload = { From: 0, PageSize: 1000, Parameter: { AirlineId: airlineId } };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getFlight(flightNumber) {
  let payload = {
    From: 0,
    PageSize: 1,
    Parameter: { FlightNumber: flightNumber }
  };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/search?showdetails=true`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function manageAirport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/airport/save`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function manageAirline(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/airline/save`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function manageFlight(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/save`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      /*Custom process of error message for flight because
       *the response is different from other API
       * I'm too lazy to report this
       * */
      let errorMessage = "";
      if (error.response === undefined) {
        errorMessage = "Please, check your internet connectivity!";
      } else {
        errorMessage = error.response.data
          ? error.response.data.ErrorMessages.join(",")
          : "Unable to handle request";
      }
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function bulkDeleteManifest(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/manifest/bulkdelete_v2`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getUnmatchPayments(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/payment/ReconciliationSearch`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getUnmatchedDomesticPayments(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/UnmatchedPayment/GetUnmatchedPayments`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function deleteManifestByReference(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/Delete?referenceId=${
        payload.ReferenceId
      }`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadManifest(payload, downloadType) {
  return appHelpers
    .postBinaryRequest(
      `${
        appConstants.PAS_URL
      }/api/manifest/downloadfmdmanifest?DownloadTypeId=${downloadType}`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function downloadInvoiceReport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/BillSummary/DownloadInvoiceReconciliation`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function downloadProformaReport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/proforma/downloadreport`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getInvoiceIssuers(payload) {
  return appHelpers
    .getRequest(
      `${
        appConstants.PAS_URL
      }/api/BillSummaryFile/GetBillBreakdown?liftingOperator=${
        payload.AirlineCode
      }&currency=${payload.Currency}&billSummaryFileId=${
        payload.BillSummaryFileId
      }`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function generateInvoice(invoiceId) {
  return appHelpers
    .getRequest(
      `${
        appConstants.PAS_URL
      }/api/BillSummary/Invoice?billsummaryId=${invoiceId}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadPdfAndExcel(payload, downloadType) {
  return appHelpers
    .postBinaryRequest(
      `${
        appConstants.PAS_URL
      }/api/aggregate/downloadstatementoftscreport?DownloadTypeId=${downloadType}`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function pdmDownloadExcel(payload, downloadType) {
  return appHelpers
    .postBinaryRequest(
      appConstants.PAS_URL +
        "/api/postdeparturemanifest/downloadpdmcomparisonasxls",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function pdmDownloadPdf(payload, downloadType) {
  return appHelpers
    .postBinaryRequest(
      appConstants.PAS_URL +
        "/api/postdeparturemanifest/downloadpdmcomparisonaspdf",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function billedPerAirportDownloadPdf(payload) {
  return appHelpers
    .postRequest(
      appConstants.PAS_URL + "/api/airportbill/DownloadAsPdf",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function billedPerAirportDownloadXls(payload) {
  return appHelpers
    .postRequest(
      appConstants.PAS_URL + "/api/airportbill/DownloadAsXls",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function paymentReconciliation(payload) {
  return appHelpers
    .postRequest(
      appConstants.PAS_URL + "/api/Payment/ReconciliationDownload",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getIATAReports(payload) {
  let url_append =
    "userName=" + payload.username + "&isLocal=" + payload.isLocal;
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Iata/GetReports?${url_append}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function generateDomesticIATAReports(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Iata/DomReport`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function generateInternationalIATAReports(payload) {
  let payload_url =
    "?airlineId=" +
    payload.airlineId +
    "&airlineCode=" +
    payload.airlineCode +
    "&airlineName=" +
    payload.airlineName +
    "&start=" +
    payload.start +
    "&end=" +
    payload.end +
    "&notifyEmail=" +
    payload.notifyEmail +
    "&userName=" +
    payload.userName +
    "&sourceAirportId=" +
    payload.sourceAirportId;
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Iata/Report${payload_url}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function markReportDownloaded(jobId) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Iata/MarkReportDownloaded?jobId=${jobId}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getDashboardReport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/File/SearchDashboard`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getFTPCredentials(pageSize, fromPage) {
  let payload = { From: fromPage, PageSize: pageSize, Parameter: {} };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/FtpCredential/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    });
}

function manageFTPCredential(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/FtpCredential/Save`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function deleteFTPCredential(credentialId) {
  return appHelpers
    .postRequest(
      appConstants.PAS_URL + "/api/FtpCredential/Delete?id=" + credentialId,
      null,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function uploadBillingSummary(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/billsummaryfile/upload_v2`,
      payload,
      authFileHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function uploadPayment(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/payment/processfileasmultipartcontent`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(
        res.data,
        appConstants.SUCCESS_RESPONSE
      );
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function uploadManifest(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/uploadmanifest/upload`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(
        res.data,
        appConstants.SUCCESS_RESPONSE
      );
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getProformaReport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/proforma/searchreport`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      /*Custom process of error message for proforma because
       *the response is different from other API
       * I'm too lazy to report this
       * */
      let errorMessage = "";
      if (error.response === undefined) {
        errorMessage = "Please, check your internet connectivity!";
      } else {
        errorMessage = error.response.data
          ? error.response.data.Message
          : "Unable to handle request";
      }
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getSecurityChargeReport(payload) {
  return appHelpers
      .postRequest(
          `${appConstants.PAS_URL}/api/SecurityCharge/SearchReportBreakDown`,
          payload,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        /*Custom process of error message for proforma because
         *the response is different from other API
         * I'm too lazy to report this
         * */
        let errorMessage = "";
        if (error.response === undefined) {
          errorMessage = "Please, check your internet connectivity!";
        } else {
          errorMessage = error.response.data
              ? error.response.data.Message
              : "Unable to handle request";
        }
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

function downloadSecurityChargeReport(payload) {
  return appHelpers
      .postRequest(
          `${appConstants.PAS_URL}/api/SecurityCharge/DownloadReport`,
          payload,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        /*Custom process of error message for proforma because
         *the response is different from other API
         * I'm too lazy to report this
         * */
        let errorMessage = "";
        if (error.response === undefined) {
          errorMessage = "Please, check your internet connectivity!";
        } else {
          errorMessage = error.response.data
              ? error.response.data.Message
              : "Unable to handle request";
        }
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}
function getUsersByOrganization(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/User/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getWorkFlowProcess() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Workflow/GetWorkflowProcess`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getWorkFlows(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/workflow/search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function createWorkflow(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/workflow/save`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getWorkFlowUsers(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/workflow/searchworkflowactionuser`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function createWorkflowUser(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/workflow/saveworkflowactionuser`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function removeWorkflowUser(id) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/workflow/deleteworkflowactionuser?id=${id}`,
      {},
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getIATAValidation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/Search`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function postIATAValidation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/Initiate`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchIATAValidationDetails(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/SearchDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function updateIATAValidationDetail(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/UpdateDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function transitionIataWorkflowState(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/TransitionWorkflowState`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function reInitializeWorkflowState(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/IataValidation/ReInitializeWorkflowState`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function addBulkPdm(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PostDepartureManifest/InsertBulk`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function searchAppEntityTypes(AppId) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/RoleEntity/Application?appId=${AppId}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function createMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/CreateMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/SearchMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function approveMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/ApproveMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function rejectMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/RejectMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function searchManifestPullModes(payload) {
  return (
    appHelpers
      .postRequest(
        `${
          appConstants.PAS_URL
        }/api/transactionmonitor/manifestprocessbypullmode`,
        payload,
        authHeader()
      )
      // return appHelpers.postRequest(`http://avp.test.vggdev.com/api/TransactionMonitor/ManifestProcessByPullMode`, payload, authHeader())
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function searchManifestProcessDuration(payload) {
  return (
    appHelpers
      .postRequest(
        `${
          appConstants.PAS_URL
        }/api/transactionmonitor/manifestprocessbyduration`,
        payload,
        authHeader()
      )
      // return appHelpers.postRequest(`http://avp.test.vggdev.com/api/TransactionMonitor/ManifestProcessByDuration`, payload, authHeader())
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function searchManifestStatus(payload) {
  return (
    appHelpers
      .postRequest(
        `${
          appConstants.PAS_URL
        }/api/transactionmonitor/manifestprocessbystatus`,
        payload,
        authHeader()
      )
      // return appHelpers.postRequest(`http://avp.test.vggdev.com/api/TransactionMonitor/ManifestProcessByStatus`, payload, authHeader())
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}
function searchAirlineLocations(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineMetrics/SearchAirlineLocationDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getFlagMetrics() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineMetrics/GetFlagMetric`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getTicketClass() {
  // return appHelpers.getRequest(`${appConstants.PAS_URL}/api/AirlineMetrics/GetFlagMetric`, authHeader())
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/TicketCategory/GetTicketClass`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getTicketCategory() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/TicketCategory/GetTicketCategory`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTicketCategoryDetails(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/TicketCategory/SearchTicketCategoryDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveTicketCategoryDetails(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/TicketCategory/SaveTicketCategoryDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponseAlt2(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function createFlagMetrics(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineMetrics/SaveFlagMetric`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function createAirlineLocation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineMetrics/SaveAirlineLocationDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function createTicketClass(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/TicketCategory/SaveTicketCategoryDetails`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadInvoiceReconciliationReport(payload) {
  return appHelpers
      .postRequest(
          `${appConstants.PAS_URL}/api/BillSummary/DownloadInvoiceSummary`,
          payload,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

function downloadFinalDestinationReport(payload) {
  return appHelpers
      .getRequest(
          `${appConstants.PAS_URL}/api/Report/DownloadFinalDestinationReport?startdate=${payload.startdate}&enddate=${payload.enddate}&airlineId=${payload.airlineId}&islocal=${payload.islocal}`,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

    function getDataCount() {
      return appHelpers
          .getRequest(
              `${appConstants.PAS_URL}/api/manifest/getdatacount`,
              // `http://fmd.prod.vggdev.com/api/v2/manifest/getdatacount`,
              authHeader()
          )
          .then(res => {
            return appHelpers.formatPromiseResponse(res);
          })
          .catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            return appHelpers.formatPromiseResponse(
                errorMessage,
                appConstants.ERROR_RESPONSE
            );
          });
    }

function indexManifest(payload) {
  return appHelpers
      .getRequest(
          `${appConstants.PAS_URL}/api/manifest/indexbydate?sdate=${payload.sdate}&edate=${payload.edate}&dateType=${payload.dateType}`,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

function getAirlineWallet(payload) {
  return appHelpers
      .postRequest(
          `${appConstants.PAS_URL}/api/AirlineWallet/GetWalletsHistoryFID`,
          // `https://fid2.test.vggdev.com/api/AirlineWallet/GetWalletsHistory`,
          payload,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

function downloadWalletHistory(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWallet/DownloadWalletHistoryFID`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAuditTrail(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AuditTrail/SearchAuditTrail`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAuditActions() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AuditTrail/GetAllAuditAction`,
      
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function InitiateDisputeLog(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dispute/IniatiateDispute`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approveDisputeLog(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dispute/ApproveDispute`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function rejectDisputeLog(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dispute/RejectDispute`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveDisputeLog(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dispute/SaveDispute`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchDispute(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dispute/SearchDispute`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getTicketNumbers(payload) {
  return appHelpers
    .postRequest(
      `http://fmd.test.vggdev.com/api/Dispute/GetTicketNumber`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchUploadManifest(payload) {
  return appHelpers
    .postRequest(
   `${appConstants.PAS_URL}/api/UploadManifest/SearchManualUploadLog`,     
    payload,
      // authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getDashboardRecord(payload) {
  return appHelpers
      .getRequest(
          `${appConstants.PAS_URL}/api/Dashboard/SummaryFMD?startDate=${payload.startDate}&endDate=${payload.endDate}&islocal=${payload.islocal}`,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

function getFaqs(payload) {
  return appHelpers
    .postRequest(
      // `${appConstants.PAS_URL}/api/BillSummary/Search`,
      `${appConstants.FAQ_URL}/api/Faq/GetProductFaqs`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAggregateNewPassengers(payload) {
  return appHelpers
    .postRequest(
      // `${appConstants.PAS_URL}/api/BillSummary/Search`,
      `https://avipay.test.vggdev.com/api/Aggregate/GetAggregateNewPassengers`,
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res.data);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchTicketInfo(payload) {
  return appHelpers
      .postRequest(
          `${appConstants.PAS_URL}/api/manifest/GetPassengerByTicketNumber`, payload,
          authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
            errorMessage,
            appConstants.ERROR_RESPONSE
        );
      });
}

// new billed per airport download api
function newbilledPerAirportDownloadPdf(payload) {
  return appHelpers
    .postBinaryRequest(
      appConstants.PAS_URL + "/api/airportbill/NewDownloadAsPdf",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function newbilledPerAirportDownloadXls(payload) {
  return appHelpers
    .postBinaryRequest(
      appConstants.PAS_URL + "/api/airportbill/NewDownloadAsXls",
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// function updatePdmRecord(payload) {
//   return appHelpers
//       .postRequest(
//           `${appConstants.PAS_URL}/api/PostDepartureManifest/update`, payload,
//           authHeader()
//       )
//       .then(res => {
//         return appHelpers.formatPromiseResponse(res);
//       })
//       .catch(error => {
//         let errorMessage = appHelpers.interpretErrorResponse(error);
//         return appHelpers.formatPromiseResponse(
//             errorMessage,
//             appConstants.ERROR_RESPONSE
//         );
//       });
// }

function updatePdmRecord(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PostDepartureManifest/update`, 
      payload,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadAggregateTSC(url) {
  return appHelpers
    .getBinaryRequest(
      `${
        appConstants.PAS_URL
      }/api/Aggregate/DownloadTSCStatementByUrl?url=${url}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}



function downloadSpecificIataReport(url) {
  return appHelpers
    .getBinaryRequest(
      `${
        appConstants.PAS_URL
      }/api/AirportBill/DownloadFileByUrl?url=${url}`,
      authHeader()
    )
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}


// WEBPACK FOOTER //
// ./src/_services/common.service.js